import React from 'react';
import { CTACard } from './CtaCard';
import { Grid } from './Grid';
import { Section } from './Section';

export const VacancyNotFound = () => (
  <Section contained>
    <Grid desktopColumns="2">
      <CTACard
        title="Find your next job at KFH"
        lead="Joining KFH means so much more than just working for one of London’s leading property services groups."
        backgroundColour="brand"
        shadow
        customButton={{
          label: 'View all jobs',
          eventClickBladeId: 'careersPageLink',
          url: '/careers/vacancies/',
        }}
      />
    </Grid>
  </Section>
);
